"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;
exports.getUsersById = getUsersById;
exports.search = search;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _userService = require("@insided/shared/services/userService");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _utils = require("./utils");

/**
 * Search users by query string
 * @param query - The search query string
 * @returns Promise resolving to an array of users matching the query
 * @throws Error if the request fails or in non-browser environment
 * @example
 * const users = await User.search('john')
 */
function search(_x) {
  return _search.apply(this, arguments);
}
/**
 * Find users by their IDs
 * @param ids - Array of user IDs to fetch
 * @returns Promise resolving to an object keyed by user ID with user data
 * @throws Error if the request fails or in non-browser environment
 * @example
 * const users = await User.findUserById([1, 2, 3])
 * const user1 = users[1]
 */


function _search() {
  _search = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(query) {
    var searchParams, response, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context.next = 2;
              break;
            }

            throw new Error('search can only be called in a browser environment');

          case 2:
            if (!(!query || typeof query !== 'string')) {
              _context.next = 4;
              break;
            }

            throw new Error('Search query is required and must be a string');

          case 4:
            _context.prev = 4;
            searchParams = new URLSearchParams({
              query: query
            });
            _context.next = 8;
            return fetch((0, _absoluteUrlRuntime.resolveUrl)("/member/_searchUser?".concat(searchParams), _absoluteUrlRuntime.UrlSourceType.Api));

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            throw new Error("Failed to search users: ".concat(response.statusText));

          case 11:
            _context.next = 13;
            return response.json();

          case 13:
            data = _context.sent;
            return _context.abrupt("return", Array.isArray(data) ? data : []);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](4);
            console.error('Error searching users:', _context.t0);
            throw _context.t0;

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 17]]);
  }));
  return _search.apply(this, arguments);
}

function getUsersById(_x2) {
  return _getUsersById.apply(this, arguments);
}
/**
 * User API service
 */


function _getUsersById() {
  _getUsersById = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(ids) {
    var response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context2.next = 2;
              break;
            }

            throw new Error('findUserById can only be called in a browser environment');

          case 2:
            if (!(!Array.isArray(ids) || ids.length === 0)) {
              _context2.next = 4;
              break;
            }

            throw new Error('User IDs array is required and must not be empty');

          case 4:
            _context2.prev = 4;
            _context2.next = 7;
            return (0, _userService.fetchUserInfo)(ids);

          case 7:
            response = _context2.sent;
            return _context2.abrupt("return", Object.values(response) || {});

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](4);
            console.error('Error fetching users by ID:', _context2.t0);
            throw _context2.t0;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 11]]);
  }));
  return _getUsersById.apply(this, arguments);
}

var User = {
  search: search,
  getUsersById: getUsersById
};
exports.User = User;